import { transformTitleToId } from 'helpers/string'
import React, { useEffect } from 'react'
import { createPortal } from 'react-dom'
import { useTranslation } from 'react-i18next'

function InPageNavPortal({ accordion }) {
  const { t } = useTranslation()
  const title = t('title.local_page')
  const mobileNodeID = 'reactMobileInstAndFakID'
  const desktopNodeID = 'reactInstAndFakID'

  useEffect(() => {
    const { mobilePortal, mobileNode } = createNode(
      '.accordion .in-page-nav__list',
      mobileNodeID
    )
    const { desktopPortal, desktopNode } = createNode(
      ':not(button.accordion) .in-page-nav__list',
      desktopNodeID
    )

    return () => {
      mobilePortal.removeChild(mobileNode)
      desktopPortal.removeChild(desktopNode)
    }
  }, [])

  /**
   *
   * @param {String} selector - id of portal
   * @param {String} id - unique id to add to list item
   * @returns {object, node}
   */
  const createNode = (selector, id) => {
    const portal = document.querySelector(selector)
    const links = document.querySelectorAll('article.node h2')

    const headingIndex = parseInt(
      Object.keys(links)
        .filter((heading) => links[heading].innerHTML == title)
        .map((index) => index)
        .toString()
    )

    const node = document.createElement('LI')
    node.id = id
    node.className = 'in-page-nav__item'

    portal.insertBefore(node, portal.children[headingIndex])
    return { portal, node }
  }

  const contentView = (
    <a href={`#${transformTitleToId(title)}`} className="in-page-nav__link">
      {title}
    </a>
  )

  const queryContainerMobile = document.querySelector(`#${mobileNodeID}`)
  const queryContainer = document.querySelector(`#${desktopNodeID}`)

  return (
    <>
      {queryContainerMobile &&
        createPortal(
          contentView,
          queryContainerMobile,
          'reactMobileInstAndFakUniqueKey'
        )}

      {queryContainer &&
        createPortal(contentView, queryContainer, 'reactInstAndFakUniqueKey')}
    </>
  )
}

export default InPageNavPortal
